<template>
  <b-nav-item-dropdown>
    <template
      slot="button-content"
      class="pr-1"
    >
      <font-awesome-icon
        :icon="currentIcon"
        :size="iconSize"
        class="fa-w-20 mr-2"
      /><span data-cy="builder-nav-menu-title">{{ currentTitle }}</span>
    </template>

    <BuilderNavItem
      v-for="item in filteredSidepanels"
      :key="item.sidepanel"
      v-bind="navItemProps(item)"
    />
  </b-nav-item-dropdown>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { useBuilderStore } from '@/store/admin/builder'

import {
  BUILDER_SIDEPANELS,
  BuilderSidepanel,
} from '@/views/builder/builderComponentDefinitions'
import BuilderNavItem from '@/components/builder/BuilderNav/BuilderNavItem.vue'

const components = {
  BuilderNavItem,
}

// eslint-disable-next-line no-use-before-define
@Component<BuilderNavMenu>({
  components,
  watch: {
    sidepanelParam: {
      handler (sidepanel?: string) {
        if (sidepanel) {
          this.builder.setLastUsedSidepanel(sidepanel)
        }
      },
      immediate: true,
    },
  },
})
export default class BuilderNavMenu extends Vue {
  builder = useBuilderStore()
  iconSize = 'lg'

  get showMap () {
    return this.$typedStore.visualisationApp.showMap
  }

  get imageUploading () {
    return this.$typedStore.primary.entities.images.imageUploading
  }

  get sidepanelParam () {
    return this.$typedStore.currentRoute.params.sidepanel
  }

  get commonProps () {
    return {
      currentSidepanelParam: this.sidepanelParam,
      disabled: this.imageUploading,
      iconSize: this.iconSize,
    }
  }

  get currentSidepanel () {
    return BUILDER_SIDEPANELS.find(({ sidepanel }) => sidepanel === this.sidepanelParam)
  }

  get currentIcon () {
    return this.currentSidepanel?.icon
  }

  get currentTitle () {
    return this.currentSidepanel?.title
  }

  get filteredSidepanels () {
    return BUILDER_SIDEPANELS
      .filter(sidePanel => sidePanel.appTypes.includes(this.$typedStore.primary.app.app.appType!))
      .filter(({ mapOnly }) => mapOnly ? this.showMap : true)
  }

  navItemProps (item: BuilderSidepanel) {
    return {
      ...item,
      ...this.commonProps,
    }
  }
}
</script>
